import { useEffect, useState } from "react";
import Button from "./Buttons.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import { ButtonLink } from "../../models/ButtonLink.ts";
import VariablePicker from "../Common/VariablePicker.tsx";
import { pruneStaleBodyEdge } from "../../utils/EdgeCleanup.ts";

interface TextButtonProps {
    nodeContent: any;
    nodeId: string;
    subNodeId: string;
}

const TextButton: React.FC<TextButtonProps> = (data) => {
    const { nodes, setNodes, edges, setEdges } = useFlowStore();
    const [text, setText] = useState<string>("");
    const [buttons, setButtons] = useState<ButtonLink[]>([]);

    useEffect(() => {
        const node = nodes.filter((node) => (node.data as CanvasNodeData).id == data.nodeId)[0];
        if (!!node) {
            const content = (node.data as CanvasNodeData).content.filter((con) => con.id == data.subNodeId)[0];
            if (!!content) {
                setButtons((content.data as any)?.buttons);
                setText((content.data as any)?.text);
            }
        }
    }, []);

    const insertVariable = (varName: string) => {
        setText(`${text}{{${varName}}}`);
    };

    useEffect(() => {
        // console.log(nodes);
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        buttons: buttons,
                                        text: text
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [text, buttons]);

    // The body-level connector lives at the node header now (see NodeHeader.tsx), not on
    // any individual bubble — but a stale wire from it can still end up pointing at a
    // non-delay target if buttons are added after the fact, so keep pruning that here.
    useEffect(() => {
        pruneStaleBodyEdge(data.nodeId, edges, nodes, setEdges);
    }, [buttons]);

    return (
        <div className="node-body">
            <div className="flex justify-between items-center mb-1">
                <span className="font-label">Message</span>
                <VariablePicker onSelect={insertVariable} />
            </div>
            <textarea
                placeholder="Type message..."
                value={text}
                onChange={(event) => setText(event.target.value)}
            />
            <Button actionButtons={buttons} setActionButtons={setButtons} />
        </div>
    );
};

export default TextButton;
